import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';

import CurrencyFormats from 'commons-vehicle/constants/currencyFormats.js';

import './VehicleRebate.scss';

const VehicleRebate = ({ rebate, electricRebate }) => {
    const hasValidRebate = (rebate && rebate > 0) || (electricRebate && electricRebate > 0);
    if (!hasValidRebate) {
        return null;
    }
    return (
        <div className="vehicle-rebate">
            {rebate > 0 && (
                <div className="vehicle-rebate-single">
                    <icon className="icon-promo2 is-price" />
                    <span>
                        {LocaleService.t('VEHICLE_STATUS.REBATE', {
                            rebate: LocaleService.l(rebate, CurrencyFormats.CURRENCY_0),
                        })}
                    </span>
                </div>
            )}
            {electricRebate > 0 && (
                <div className="vehicle-rebate-single">
                    <icon className="icon-electric-vehicle sr-sucessColor" />
                    <span>{LocaleService.t('VEHICLE_STATUS.ELECTRIC_REBATE')}</span>
                </div>
            )}
        </div>
    );
};

VehicleRebate.defaultProps = {
    rebate: 0,
    electricRebate: 0,
};
VehicleRebate.propTypes = {
    rebate: PropTypes.number,
    electricRebate: PropTypes.number,
};

VehicleRebate.displayName = 'VehicleRebate';

export default VehicleRebate;



// WEBPACK FOOTER //
// ./src/Vehicle/components/VehicleRebate/VehicleRebate.jsx